const APIDASH = "https://api.sponsa.app";
//const APIDASH = "https://localhost:44375";
//const APIDASH = "https://sponsaapi.validatione.com";

export default APIDASH;
